export default __webpack_public_path__ + "static/media/Commingsoon.df3be1a6.svg";